import { getTextEmotionColor, getEmotionColor, bgColors } from "../utils";

const VictoryPieCustomTooltip = (props) => {
  if (!props.datum?.x) return null;
  const { datum, x, y, tooltipCounts, state } = props;

  if (!datum || !tooltipCounts || !state) return null;

  const emotion = datum.x;
  const tooltipData = tooltipCounts?.[emotion];
  if (!tooltipData) return null;

  const dataForEmotion = state.counts.find((d) => d.name === emotion);
  if (!dataForEmotion) return null;

  const currentPercentage = dataForEmotion.currentPercent;
  const comparePercentage = dataForEmotion.comparePercent;

  const currentPeriod = state.chosenTime || "Current";
  const comparePeriod = state.chosenTimeCompare || "";

  const sortedStudents = tooltipData
    ? Object.entries(tooltipData)
        .sort(([, a], [, b]) => b - a)
        .map(([email, count]) => ({
          name: state.studentEmailToNameMap?.[email] || email,
          count,
        }))
    : [];

  return (
    <div
      className="absolute z-20 bg-white shadow-lg p-3 w-[260px] max-w-[calc(100%-24px)]"
      style={{
        left: props.x,
        top: props.y,
        transform: "translate(-50%, -50%)",
      }}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="capitalize font-semibold text-base text-700">
          {emotion}
        </span>
        <img
          src={`/images/emotions/${emotion}.png`}
          alt={emotion}
          className="w-5 h-5"
        />
      </div>
      <div
        className="text-sm 2xl:text-base mb-2 p-2 text-center"
        style={{ backgroundColor: bgColors[emotion] || "#888" }}
      >
        <div className="grid grid-cols-3 gap-1">
          <div className="font-semibold">Current</div>
          <div className="font-semibold">Prev {comparePeriod}</div>
          <div className="font-semibold">Change</div>

          <div className="font-bold">{currentPercentage}%</div>
          <div className="text-gray-400">{comparePercentage}%</div>
          <div
            className={`flex items-center justify-center gap-1 font-semibold ${getTextEmotionColor(
              emotion
            )}`}
          >
            {currentPercentage === comparePercentage ? (
              <span>–</span>
            ) : currentPercentage > comparePercentage ? (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 10l7-7 7 7M12 3v18"
                  />
                </svg>
                <span>{Math.abs(currentPercentage - comparePercentage)}%</span>
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 14l-7 7-7-7M12 3v18"
                  />
                </svg>
                <span>{Math.abs(currentPercentage - comparePercentage)}%</span>
              </>
            )}
          </div>
        </div>
      </div>
      <h3 className="font-semibold text-sm 2xl:text-base text-700 py-2 pr-2">
        Students who've felt
        <span className={`ml-2 ${getTextEmotionColor(emotion)}`}>
          {emotion}
        </span>
      </h3>
      {sortedStudents.length > 0 ? (
        <div className="max-h-40 overflow-y-auto">
          <table className="w-full text-left pt-2 text-sm 2xl:text-base text-400">
            <tbody className="divide-y divide-gray-100">
              {sortedStudents.map((student, i) => (
                <tr
                  key={i}
                  className={`
                      ${i % 2 === 0 ? getEmotionColor(emotion) : "bg-white"}
                      hover:bg-gray-50
                    `}
                >
                  <td className="p-2">{student.name}</td>
                  <td className="p-2 text-right">{student.count}x</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500 italic">
          No student-specific data available.
        </p>
      )}
    </div>
  );
};

export default VictoryPieCustomTooltip;
